module.exports = __webpack_public_path__ + "static/media/japan.3d8e8b44.svg";